/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
import * as types from '@/lib/definition/types'
import moment from "moment-timezone";
moment.locale('ja')

export interface ProjectAssignState {
  Clietns: Array<types.ClientParam>
  [key: string]: any;
}

const ProjectAssign = defineModule({
  state: (): ProjectAssignState => {
    return {
      Clietns: [],
      githubusername: null,
      orgs:[],
    }
  },
  getters: {
    emptyProject: (...args): types.ProjectAssignByProjectParamLocal => {
      return {
        projectId: null,
        clientId: '',
        tenantId: '',
        name: '',
        nameKana: '',
        isActive: true,
        startDate: null,
        endDate: null,
        startDateDisp: null,
        startDateLocal: null,
        endDateDisp: null,
        endDateLocal: null,
        branchId: null,
        code: '',
        projectAssignByProjectParamAssignsJSON: '',
        assigns: []
      }
    },
    emptyProjectAssign: (...args): types.ProjectAssignByProjectParamAssignLocal => {
      return {
        projectAssignId: null,
        projectId: '',
        startDate: '',
        lastDate: null,
        startDateDisp: null,
        startDateLocal: null,
        lastDateDisp: null,
        lastDateLocal: null,
        appUserId:'',
        enabled:true,
        startDateMenu: false,
        lastDateMenu: false,
        displayName: '',
        supplimentalName: '',
        isLeader: false
      }
    },
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    }
  },
  actions: {
    async listAll(context): Promise<Array<types.ProjectAssignByProjectParamLocal>> {
      const { rootState, commit, dispatch } = moduleActionContext(context, ProjectAssign)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<Array<types.ProjectAssignByProjectParam>>>('/api/projectassign/listall', "プロジェクト情報の取得に失敗しました", {}, rootState.Login.accessToken)
      var list = await dispatch.convertProjectToLocal(retval.data.data)
      commit.SET_VALUE({name: 'Projects', value: list})
      return list
    },
    async listAllByUser(context): Promise<Array<types.ProjectAssignByUserParamLocal>> {
      const { rootState, commit, dispatch } = moduleActionContext(context, ProjectAssign)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<Array<types.ProjectAssignByUserParam>>>('/api/projectassign/listallbyuser', "プロジェクト情報の取得に失敗しました", {}, rootState.Login.accessToken)
      var list = await dispatch.convertProjectAssignUserToLocal(retval.data.data)
      return list
    },
    async listAllUser(context): Promise<Array<types.ProjectAssignByProjectParamUserLocal>> {
      const { rootState, commit, dispatch } = moduleActionContext(context, ProjectAssign)
      const retval = await Lib.Ajax.getHandleError<types.DataResponse<Array<types.ProjectAssignByProjectParamUser>>>('/api/projectassign/listuser', "ユーザー情報の取得に失敗しました", {}, rootState.Login.accessToken)
      var list = retval.data.data.map(obj => {
        return {
          appUserId:obj.appUserId,
          displayName: obj.displayName,
          supplimentalName: obj.supplimentalName,
          displayNameWithSupplimentalName: obj.displayName + (obj.supplimentalName != null ? ' ' + obj.supplimentalName : '')
        } 
      })
      return list
    },
    defaultProject(context) : types.ProjectParamWithLocalDate {
      const { rootState } = moduleActionContext(context, ProjectAssign)
      return {
        projectId: null,
        clientId: '',
        tenantId: rootState.Login.userInfo.tenantId,
        name: '',
        nameKana: '',
        isActive: true,
        startDate: null,
        endDate: null,
        startDateDisp: null,
        startDateLocal: null,
        endDateDisp: null,
        endDateLocal: null,
        startDateMenu:false,
        endDateMenu: false,
        branchId: null,
        code: '',
        projectRepositoriesJSON: '',
        projectRepositories:[],
        workOrderNumbersJSON: '',
        defaultWorkOrderNumberId: null,
        workOrderNumbers: []
      }
    },
    async addAssign(context, payload: types.ProjectAssignByProjectParamAssignLocal): Promise<boolean> {
      const { rootState, dispatch } = moduleActionContext(context, ProjectAssign)
      var toSubmit = await dispatch.convertProjectAssignFromLocal(payload)
      let param = Object.assign({}, toSubmit) as unknown as { [key: string]: string; }
      param.lastDate = payload.lastDate == null ? '' : param.lastDate
      param.projectAssignId = payload.projectAssignId == null ? '' : param.projectAssignId
      if (payload.projectAssignId == '' || payload.projectAssignId == null) {
        const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/projectassign/addassign', "アサインの追加に失敗しました。", param, rootState.Login.accessToken)
        var groups = retval.data.data
        return groups
      } else {
        const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/projectassign/updateassign', "アサインの設定に失敗しました。", param, rootState.Login.accessToken)
        groups = retval.data.data
        return groups  
      }
    },
    async makeActive(context, payload: types.ProjectAssignByUserParamProjectLocal): Promise<boolean> {
      const { rootState, dispatch } = moduleActionContext(context, ProjectAssign)
      var toSubmit = await dispatch.convertProjectAssignByUserProjectFromLocal(payload)
      let param = Object.assign({}, toSubmit) as unknown as {[key: string]: string;}
      param.endDate = payload.endDate == null ? '' : param.endDate
      param.startDate = payload.startDate == null ? '' : param.startDate
      const retval = await Lib.Ajax.postHandleError<types.DataResponse<boolean>>('/api/projectassign/makeactive', "アサインの設定に失敗しました。", param, rootState.Login.accessToken)
      var result = retval.data.data
      return result  
    },
    defaultProjectRepositories(context, project:types.ProjectParamWithLocalDate):types.ProjectRepositoryParam {
      return {
        projectRepositoryId: null,
        projectId: project.projectId,
        organzationName: '',
        repositoryName: '',
        organizationId: 0,
        repositoryId: 0,
        url: ''
      }
    },
    convertProjectAssignUserToLocal(context,users:Array<types.ProjectAssignByUserParam>): Array<types.ProjectAssignByUserParamLocal> {
      const { rootState, dispatch } = moduleActionContext(context, ProjectAssign)
      return users.map(u => {
        var projects = u.projectAssignByUserParamProjectsJSON == null ? [] : JSON.parse(u.projectAssignByUserParamProjectsJSON) as types.ProjectAssignByUserParamProject[]
        var locals = projects.map((p) => { return {
          projectAssignId: p.projectAssignId,
          projectId: p.projectId,
          tenantId: p.tenantId,
          isActive: p.isActive,
          name: p.name,
          nameKana: p.nameKana,
          startDate: p.startDate,
          endDate: p.endDate,
          clientId: p.clientId,
          branchId: p.branchId,
          code: p.code,
          isCurrent: p.isCurrent,
          startDateDisp: p.startDate == null ? null : moment.tz(p.startDate, moment.tz.guess()).format('YYYY-MM-DD'),
          startDateLocal: p.startDate == null ? null : moment.tz(p.startDate, moment.tz.guess()).format('YYYY-MM-DD'),
          endDateDisp: p.endDate == null ? null : moment.tz(p.endDate, moment.tz.guess()).format('YYYY-MM-DD'),
          endDateLocal: p.endDate == null ? null : moment.tz(p.endDate, moment.tz.guess()).format('YYYY-MM-DD'),
        }})
        return {
          appUserId: u.appUserId,
          displayName: u.displayName,
          supplimentalName: u.supplimentalName,
          projectAssignByUserParamProjectsJSON: u.projectAssignByUserParamProjectsJSON,
          projects: locals
        }
      }) as Array<types.ProjectAssignByUserParamLocal>
    },
    convertProjectToLocal(context,projects:Array<types.ProjectAssignByProjectParam>): Array<types.ProjectAssignByProjectParamLocal> {
      const { rootState, dispatch } = moduleActionContext(context, ProjectAssign)
      return projects.map(p => {
        var assigns = p.projectAssignByProjectParamAssignsJSON == null ? [] : JSON.parse(p.projectAssignByProjectParamAssignsJSON) as types.ProjectAssignByProjectParamAssign[]
        var locals = assigns.map((p) => { return {
          projectId: p.projectId,
          startDate: p.startDate,
          lastDate: p.lastDate,
          appUserId: p.appUserId,
          enabled: p.enabled,
          projectAssignId: p.projectAssignId,
          displayName: p.displayName,
          supplimentalName: p.supplimentalName,
          startDateDisp: p.startDate == null ? null : moment.tz(p.startDate, moment.tz.guess()).format('YYYY-MM-DD'),
          startDateLocal: p.startDate == null ? null : moment.tz(p.startDate, moment.tz.guess()).format('YYYY-MM-DD'),
          lastDateDisp: p.lastDate == null ? null : moment.tz(p.lastDate, moment.tz.guess()).format('YYYY-MM-DD'),
          lastDateLocal: p.lastDate == null ? null : moment.tz(p.lastDate, moment.tz.guess()).format('YYYY-MM-DD'),
          startDateMenu: false,
          lastDateMenu: false,
          isLeader: p.isLeader
        }})
        return {
          projectId: p.projectId,
          clientId: p.clientId,
          tenantId: p.tenantId,
          name: p.name,
          nameKana: p.nameKana,
          isActive: p.isActive,
          startDate: p.startDate,
          endDate: p.endDate,
          startDateDisp: p.startDate == null ? null : moment.tz(p.startDate, moment.tz.guess()).format('YYYY-MM-DD'),
          startDateLocal: p.startDate == null ? null : moment.tz(p.startDate, moment.tz.guess()).format('YYYY-MM-DD'),
          endDateDisp: p.endDate == null ? null : moment.tz(p.endDate, moment.tz.guess()).format('YYYY-MM-DD'),
          endDateLocal: p.endDate == null ? null : moment.tz(p.endDate, moment.tz.guess()).format('YYYY-MM-DD'),
          branchId: p.branchId,
          assigns: locals
        }
      }) as Array<types.ProjectAssignByProjectParamLocal>
    },
    convertProjectFromLocal(context,p:types.ProjectParamWithLocalDate): types.ProjectParam {
      const { rootState } = moduleActionContext(context, ProjectAssign)
      return {
          projectId: p.projectId,
          clientId: p.clientId,
          tenantId: p.tenantId,
          name: p.name,
          nameKana: p.nameKana,
          isActive: p.isActive,
          startDate: p.startDateLocal == null ? null : moment.tz(p.startDateLocal, moment.tz.guess()).format('YYYY-MM-DD'),
          endDate: p.endDateLocal,
          branchId: p.branchId,
          code: p.code,
          projectRepositoriesJSON: JSON.stringify(p.projectRepositories),
          workOrderNumbersJSON: JSON.stringify(p.workOrderNumbers ?? []),
          defaultWorkOrderNumberId: p.defaultWorkOrderNumberId
        }
    },
    convertProjectAssignToLocal(context,p:types.ProjectAssignByProjectParamAssign): types.ProjectAssignByProjectParamAssignLocal {
      const { rootState } = moduleActionContext(context, ProjectAssign)
      return {
          projectId: p.projectId,
          startDate: p.startDate,
          lastDate: p.lastDate,
          appUserId: p.appUserId,
          enabled: p.enabled,
          projectAssignId: p.projectAssignId,
          displayName: p.displayName,
          supplimentalName: p.supplimentalName,
          startDateDisp: p.startDate == null ? null : moment.tz(p.startDate, moment.tz.guess()).format('YYYY-MM-DD'),
          startDateLocal: p.startDate == null ? null : moment.tz(p.startDate, moment.tz.guess()).format('YYYY-MM-DD'),
          lastDateDisp: p.lastDate == null ? null : moment.tz(p.lastDate, moment.tz.guess()).format('YYYY-MM-DD'),
          lastDateLocal: p.lastDate == null ? null : moment.tz(p.lastDate, moment.tz.guess()).format('YYYY-MM-DD'),
          startDateMenu: false,
          lastDateMenu: false,
          isLeader: p.isLeader
        }
    },
    convertProjectAssignFromLocal(context,p:types.ProjectAssignByProjectParamAssignLocal): types.ProjectAssignByProjectParamAssign {
      const { rootState } = moduleActionContext(context, ProjectAssign)
      return {
          projectId: p.projectId,
          startDate: p.startDateLocal == null ? moment().format('YYYY-MM-DD') : moment.tz(p.startDateLocal, moment.tz.guess()).format('YYYY-MM-DD'),
          lastDate: p.lastDateLocal,
          appUserId: p.appUserId,
          enabled: p.enabled,
          projectAssignId: p.projectAssignId,
          displayName: p.displayName,
          supplimentalName: p.supplimentalName,
          isLeader: p.isLeader,
        }
    },
    convertProjectAssignByUserProjectFromLocal(context,p:types.ProjectAssignByUserParamProjectLocal): types.ProjectAssignByUserParamProject {
      const { rootState } = moduleActionContext(context, ProjectAssign)
      return {
        projectId: p.projectId,
        projectAssignId: p.projectAssignId,
        clientId: p.clientId,
        tenantId: p.tenantId,
        name: p.name,
        nameKana: p.nameKana,
        isActive: p.isActive,
        startDate: p.startDate,
        endDate: p.endDateLocal,
        branchId: p.branchId,
        code: p.code,
        isCurrent: p.isCurrent
      }
    },
  },
  namespaced: true
})

export default ProjectAssign